
export const UpdateAssessment = () => {
  return (
    <div>UpdateAssessment</div>
  )
}
